import { useRef, useState } from 'react'

/**
 * Reads a URL search parameter and removes it from the URL (once).
 * Returns the param value on first render, then null after cleanup.
 * Uses history.replaceState to avoid a page reload.
 */
export function useConsumeSearchParam(key: string): string | undefined {
  const consumed = useRef(false)
  const [value] = useState<string | undefined>(() => {
    if (typeof window === 'undefined') return undefined
    return new URLSearchParams(window.location.search).get(key) ?? undefined
  })

  if (value && !consumed.current) {
    consumed.current = true
    const params = new URLSearchParams(window.location.search)
    params.delete(key)
    const newUrl = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname
    window.history.replaceState({}, '', newUrl)
  }

  return value
}
